interface FormErrorAlertContainerProps {
  children: React.ReactNode
}

export const FormErrorAlertContainer: React.FC<FormErrorAlertContainerProps> = (
  { children }
) => (
  <ul className='modal-blue'>
    {children}
  </ul>
)
